<template>
    <div id="inicio">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <div class="row">
                            <template v-if="!inscripcionOK">
                                <div class="col-md-4">
                                    <div class="text-center" id="logo-inicio" style="margin-bottom: 40px">
                                        <img src="img/logo_dorado.PNG" width="150px">
                                    </div>

                                    <p class="text-justify">Si desea crear un <strong>entrenamiento
                                        personalizado</strong>,
                                        <strong>no encuentra horario</strong> que le
                                        concuerde o tiene alguna <strong>duda o problema</strong> envie un correo
                                        electronico a:
                                        <strong><a
                                            href="mailto:info@academiaplayer10.com">info@academiaplayer10.com</a></strong>
                                        o contacte con nosotros en el <strong><a
                                            href="tel:644316177">644316177</a></strong>
                                    </p>
                                </div>
                                <div class="col-md-8">
                                    <template v-if="!datosPersonales">
                                        <form role="form">
                                            <h1 class="text-center">Inscripción de
                                                jugador</h1>

                                            <div class="form-group">
                                                <p style="margin-bottom: 30px"><strong>Seleccione posición del
                                                    jugador</strong>
                                                </p>
                                                <div class="row">
                                                    <div class="col-md-6 col-6 text-center posicion"
                                                         :class="{'posicion-selected':inscripcion.posicion == 1}"
                                                         @click="inscripcion.posicion = 1; changeYears();changeModalidades(); loadDias(); ">
                                                        <img class="img-posicion" src="img/player.png">
                                                        <h2 class="titulo-posicion">Jugador de campo</h2>
                                                    </div>
                                                    <div class="col-md-6 col-6 text-center posicion"
                                                         :class="{'posicion-selected':inscripcion.posicion == 2}"
                                                         @click="inscripcion.posicion = 2;inscripcion.sede = 'Sevilla Este'; changeYears();changeModalidades(); loadDias();">
                                                        <img class="img-posicion" src="img/goalkeeper.png">
                                                        <h2 class="titulo-posicion">Portero</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group" v-if="inscripcion.posicion!=0">
                                                <label for="sede"><strong>Seleccione sede de
                                                    entrenamiento</strong></label>
                                                <select name="sede" id="sede" class="form-control"
                                                        v-model="inscripcion.sede"
                                                        @change="changeYears(); loadModalidades();">
                                                    <option value="Sevilla Este">Sevilla Este (C.D. Demetrio Pichel)
                                                    </option>
                                                    <!--                                                    <option value="Santiponce" v-if="inscripcion.posicion === 1">-->
                                                    <!--                                                        Santiponce-->
                                                    <!--                                                    </option>-->
                                                    <!--                                                    <option value="Torreblanca">Torreblanca</option>-->
                                                    <!--                                                    <option value="Castilleja Cuesta">Castilleja de la Cuesta-->
                                                    <!--                                                    </option>-->
                                                </select>
                                            </div>

                                            <div class="form-group" v-if="inscripcion.posicion!=0">
                                                <label for="year"><strong>Seleccione año de nacimiento del
                                                    jugador</strong></label>
                                                <select name="year" id="year" class="form-control"
                                                        v-model="inscripcion.year" @change="loadDias();">
                                                    <option v-for="year in years" :value="year">{{ year }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="form-group" v-if="inscripcion.posicion!=0">
                                                <label for="modalidad"><strong>Seleccione modalidad</strong></label>
                                                <select name="modalidad" id="modalidad" class="form-control"
                                                        v-model="inscripcion.modalidad"
                                                        @change="loadDias()">
                                                    <option v-for="modalidad in modalidades" :value="modalidad"
                                                            v-if="(inscripcion.posicion === 1 && modalidad.portero === 0) || (inscripcion.posicion === 2 && modalidad.portero === 1)">
                                                        {{ modalidad | parseModalidad }}
                                                    </option>
                                                </select>
                                            </div>

                                            <template v-if="inscripcion.modalidad.days === 1">
                                                <div class="form-group" v-if="inscripcion.posicion!=0">
                                                    <label for="dia"><strong>Seleccione día de
                                                        entrenamiento</strong></label>
                                                    <select name="dia" id="dia" class="form-control"
                                                            v-model="inscripcion.dia"
                                                            @change="loadHoras()">
                                                        <option :value="day.dianum" v-for="day in days">{{
                                                                day.dia
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group" v-if="inscripcion.posicion!=0">
                                                    <label for="hora"><strong>Seleccione hora de
                                                        entrenamiento</strong></label>
                                                    <select name="hora" id="hora" class="form-control"
                                                            v-model="inscripcion.hora1Id">
                                                        <option v-for="hora in horas"
                                                                :value="hora.id" style='text-transform: capitalize'>
                                                            {{ hora.hora }} (GYM: {{ hora.horaGym }})
                                                        </option>
                                                    </select>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="form-group" v-if="inscripcion.posicion!=0">
                                                    <label for="dia"><strong>Seleccione 1º día de
                                                        entrenamiento</strong></label>
                                                    <select name="dia" id="dia" class="form-control"
                                                            v-model="inscripcion.dia"
                                                            @change="loadHoras(1)">
                                                        <option :value="day.dianum" v-for="day in days">{{
                                                                day.dia
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group" v-if="inscripcion.posicion!=0">
                                                    <label for="hora"><strong>Seleccione 1ª hora de
                                                        entrenamiento</strong></label>
                                                    <select name="hora" id="hora" class="form-control"
                                                            v-model="inscripcion.hora1Id">
                                                        <option v-for="hora in horas"
                                                                :value="hora.id">
                                                            {{ hora.hora }} (GYM: {{ hora.horaGym }})
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group" v-if="inscripcion.posicion!=0">
                                                    <label for="dia"><strong>Seleccione 2º día de
                                                        entrenamiento</strong></label>
                                                    <select name="dia" id="dia" class="form-control"
                                                            v-model="inscripcion.dia2"
                                                            @change="loadHoras(2)">
                                                        <option :value="day.dianum" v-for="day in days2">{{
                                                                day.dia
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group" v-if="inscripcion.posicion!=0">
                                                    <label for="hora"><strong>Seleccione 2ª hora de
                                                        entrenamiento</strong></label>
                                                    <select name="hora" id="hora" class="form-control"
                                                            v-model="inscripcion.hora2Id">
                                                        <option v-for="hora in horas2"
                                                                :value="hora.id">
                                                            {{ hora.hora }} (GYM: {{ hora.horaGym }})
                                                        </option>
                                                    </select>
                                                </div>
                                            </template>
                                        </form>

                                        <div v-if="inscripcion.posicion != 0">
                                            <hr>

                                            <div class="text-center" style="margin-top: 40px;">
                                                <button class="btn btn-lg btn-success" @click="datosPersonales=true;">
                                                    Continuar y rellenar datos personales <i
                                                    class="fas fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p>Por favor, <strong>revise</strong> los datos antes de continuar:
                                            <button class="btn btn-sm btn-warning" @click="datosPersonales=false;">
                                                <i class="fas fa-edit"></i> Cambiar datos de inscripción
                                            </button>
                                        </p>
                                        <ul>
                                            <li><strong>Posicion del jugador: </strong>
                                                <span v-if="inscripcion.posicion == 1">Jugador de campo</span>
                                                <span v-else>Portero</span>
                                            </li>
                                            <li><strong>Año de nacimiento: </strong>
                                                <span>{{ inscripcion.year }}</span>
                                            </li>
                                            <li><strong>Sede de entrenamiento: </strong>
                                                <span>{{ inscripcion.sede }}</span>
                                            </li>
                                            <li><strong>Modalidad: </strong>
                                                <span>{{ inscripcion.modalidad | parseModalidad }}</span>
                                            </li>
                                            <template v-if="inscripcion.modalidad.days === 1">
                                                <li><strong>Día de entrenamiento: </strong>
                                                    <span>{{ inscripcion.dia | parseDia }}</span>
                                                </li>
                                                <li><strong>Hora de entrenamiento: </strong>
                                                    <span>{{ retrieveHoraFromId(1, inscripcion.hora1Id) }}</span>
                                                </li>
                                            </template>
                                            <template v-else>
                                                <li><strong>1º Día de entrenamiento: </strong>
                                                    <span>{{ inscripcion.dia | parseDia }}</span>
                                                </li>
                                                <li><strong>1ª Hora de entrenamiento: </strong>
                                                    <span>{{ retrieveHoraFromId(1, inscripcion.hora1Id) }}</span>
                                                </li>
                                                <li><strong>2º Día de entrenamiento: </strong>
                                                    <span>{{ inscripcion.dia2 | parseDia }}</span>
                                                </li>
                                                <li><strong>2ª Hora de entrenamiento: </strong>
                                                    <span>{{ retrieveHoraFromId(2, inscripcion.hora2Id) }}</span>
                                                </li>
                                            </template>
                                        </ul>

                                        <template
                                            v-if="(inscripcion.hora.numJugadores >= inscripcion.maxplayers && inscripcion.maxplayers != 1)">
                                            <p class="text-danger text-justify"><strong>ATENCIÓN:</strong> Este grupo
                                                esta completo y no pueden inscribirse mas jugadores.</p>
                                            <p class="text-danger text-justify">Puede <strong>inscribirse en otro
                                                grupo</strong> pulsando en el botón "Cambiar datos de inscripcion" o
                                                puede dejar sus datos para entrar en <strong>lista de reservas.</strong>
                                            </p>
                                        </template>

                                        <h1>Datos del jugador</h1>
                                        <form role="form">
                                            <base-input
                                                label="Nombre"
                                                v-model="datosJugador.nombre"
                                                :valid="validations.nombre"
                                                @blur="checkText"
                                                placeholder="Nombre del jugador"
                                                input-classes="form-control-alternative"/>
                                            <base-input
                                                label="Apellidos"
                                                v-model="datosJugador.apellidos"
                                                :valid="validations.apellidos"
                                                @blur="checkText"
                                                placeholder="Apellidos del jugador"
                                                input-classes="form-control-alternative"/>
                                            <base-input
                                                label="Club actual"
                                                v-model="datosJugador.club"
                                                :valid="validations.club"
                                                @blur="checkText"
                                                placeholder="Club actual del jugador"
                                                input-classes="form-control-alternative"/>

                                            <base-input
                                                label="Observaciones"
                                                v-model="datosJugador.observaciones"
                                                :valid="validations.observaciones"
                                                placeholder="Alergias, medicamentos, etc..."
                                                input-classes="form-control-alternative"/>

                                            <hr>

                                            <h1>Datos del tutor</h1>

                                            <base-input
                                                label="Nombre"
                                                v-model="datosTutor.nombre"
                                                :valid="validations.nombreTutor"
                                                @blur="checkText"
                                                placeholder="Nombre del tutor"
                                                input-classes="form-control-alternative"/>
                                            <base-input
                                                label="Apellidos"
                                                v-model="datosTutor.apellidos"
                                                :valid="validations.apellidosTutor"
                                                @blur="checkText"
                                                placeholder="Apellidos del tutor"
                                                input-classes="form-control-alternative"/>
                                            <base-input
                                                label="Teléfono"
                                                v-model="datosTutor.telefono"
                                                :valid="validations.telefono"
                                                @blur="checkTelefono"
                                                placeholder="Teléfono del tutor"
                                                input-classes="form-control-alternative"/>
                                            <base-input
                                                label="Correo electrónico"
                                                v-model="datosTutor.email"
                                                :valid="validations.email"
                                                @blur="checkEmail"
                                                placeholder="Correo electrónico del tutor"
                                                input-classes="form-control-alternative"/>

                                            <base-checkbox v-model="informacionGeneral">
                                                <span>He leído y estoy de acuerdo con la <a target="_blank"
                                                                                            href="https://academiaplayer10.com/inscripcion/informacion_general.pdf"><strong><u>información general</u></strong></a></span>
                                            </base-checkbox>
                                            <base-checkbox v-model="publicacionImagenes">
                                            <span>He leído y estoy de acuerdo con la
                                                <a target="_blank"
                                                   href="https://www.academiaplayer10.com/inscripcion/autorizacion_toma_publicacion_imagenes.pdf"><strong><u>autorización para la toma y publicación de imágenes</u></strong></a>
                                            </span>
                                            </base-checkbox>
                                            <div class="text-center">
                                                <base-button id="botonGuardarInscripcion" type="primary"
                                                             @click="guardarInscripcion"
                                                             :disabled="disabledBotonGuardarInscripcion  == 1 ? true : false">
                                                    {{ textBotonGuardarInscripcion }}
                                                </base-button>
                                                <div class="text-danger" v-if="textoError">
                                                    {{ textoError }}
                                                </div>
                                            </div>
                                        </form>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-md-12">
                                    <div class="text-center">
                                        <h3>¡Bienvenido {{ datosTutor.nombre }}!</h3>
                                    </div>

                                    <template
                                        v-if="(inscripcion.hora.numJugadores >= inscripcion.maxplayers && inscripcion.maxplayers != 1)">
                                        <p class="text-justify">Le hemos <strong>enviado</strong> un correo a su
                                            dirección
                                            {{ datosTutor.email }}
                                            con los datos de la <strong>reserva</strong>
                                        </p>
                                    </template>
                                    <template v-else>
                                        <p class="text-justify">Le hemos <strong>enviado</strong> un correo a su
                                            dirección
                                            {{ datosTutor.email }}
                                            con los datos de la <strong>inscripción</strong></p>

                                        <p class="text-justify">
                                            Recuerda que debes de realizar el pago de la equipación la cual es <strong>OBLIGATORIA</strong> en la web de <a href="https://www.futbolemotion.com/es/categoria/colectivos/equipaciones-player-10" target="_blank">fútbol emotion</a> con la contraseña <strong>player10</strong>.
                                        </p>

                                        <p class="text-justify">
                                            No se podrá acceder a nuestros entrenamientos sin estar uniformado correctamente.
                                        </p>
                                    </template>

                                    <p>Si tiene alguna duda o problema pueden ponerse en contacto en 644 316 177 o
                                        <strong><a
                                            href="mailto:info@academiaplayer10.com">info@academiaplayer10.com</a></strong>
                                    </p>

                                </div>
                            </template>
                        </div>
                    </card>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'

export default {
    data: function () {
        return {
            inscripcionOK: false,
            datosPersonales: false,
            modalidades: [],
            inscripcion: {
                modalidad: null,
                posicion: 0,
                year: "2011",
                sede: "Sevilla Este",
                dia: "1",
                hora: {},
                hora1Id: null,
                hora2Id: null,
                dia2: "1",
                hora2: {},
            },
            datosJugador: {
                nombre: "",
                apellidos: "",
                club: "",
                talla: "XS",
                observaciones: ""
            },
            datosTutor: {
                nombre: "",
                apellidos: "",
                telefono: "",
                email: ""
            },
            informacionGeneral: false,
            publicacionImagenes: false,
            textoError: "",
            textBotonGuardarInscripcion: "Guardar inscripción",
            disabledBotonGuardarInscripcion: 0,
            validations: {
                nombre: 0,
                apellidos: 0,
                club: 0,
                nombreTutor: 0,
                apellidosTutor: 0,
                telefono: 0,
                email: 0
            },
            years: [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020],
            horas: [],
            horas2: [],
            days: [],
            days2: [],
        }
    },
    created() {
        this.changeYears();
        this.loadModalidades();
        // this.loadDias();
    },
    methods: {
        retrieveHoraFromId(dia, id) {
            if (dia === 1) {
                let hora = 0;

                this.horas.forEach(function (h) {
                    if (h.id === id) {
                        hora = h.hora + ' (GYM: ' + h.horaGym + ')';
                    }
                });

                return hora;
            }
            if (dia === 2) {
                let hora = 0;

                this.horas2.forEach(function (h) {
                    if (h.id === id) {
                        hora = h.hora + ' (GYM: ' + h.horaGym + ')';
                    }
                });

                return hora;
            }
        },
        changeYears() {

            if (this.inscripcion.posicion === 1) {
                this.years = [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020];
            }
            if (this.inscripcion.posicion === 2) {
                this.years = [2015, 2016, 2017, 2018, 2019, 2020];
            } else {
                this.years = [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020];
            }


            this.inscripcion.year = this.years[0];
        },
        changeModalidades() {
            if (this.inscripcion.posicion === 1) {
                this.inscripcion.modalidad = this.modalidades.find(m => m.portero === 0);
            }

            if (this.inscripcion.posicion === 2) {
                this.inscripcion.modalidad = this.modalidades.find(m => m.portero === 1);
            }
        },
        loadModalidades() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'modalidades?sede=' + vm.inscripcion.sede)
                .then(response => {
                    if (response.data.response) {
                        vm.modalidades = response.data.result;
                        vm.inscripcion.modalidad = vm.modalidades[0];
                        vm.loadDias();
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadDias(dia) {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'horas/' + this.inscripcion.sede + '/dias', {
                params: {
                    year: vm.inscripcion.year,
                    sede: vm.inscripcion.sede,
                    posicion: vm.inscripcion.posicion,
                    grupal: vm.inscripcion.modalidad ? vm.inscripcion.modalidad.maxPlayers : 8,
                }
            }).then(response => {
                if (response.data.response) {
                    this.days = response.data.result;

                    if (dia === 1) {
                        vm.days = response.data.result;
                        vm.inscripcion.dia = vm.days[0].dianum;
                    } else if (dia === 2) {
                        vm.days2 = response.data.result;
                        vm.inscripcion.dia2 = vm.days2[0].dianum;
                    } else {
                        vm.days = response.data.result;
                        vm.inscripcion.dia = vm.days[0].dianum;
                        vm.days2 = response.data.result;
                        vm.inscripcion.dia2 = vm.days2[0].dianum;
                    }

                    vm.loadHoras();
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadHoras(dia) {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'horas', {
                params: {
                    posicion: vm.inscripcion.posicion,
                    sede: vm.inscripcion.sede,
                    dia: dia === 2 ? vm.inscripcion.dia2 : vm.inscripcion.dia,
                    grupal: vm.inscripcion.modalidad.maxPlayers,
                    year: vm.inscripcion.year
                }
            }).then(response => {
                if (response.data.response) {
                    if (dia === 1) {
                        vm.horas = response.data.result;
                        vm.inscripcion.hora1Id = vm.horas[0].id;
                    } else if (dia === 2) {
                        vm.horas2 = response.data.result;
                        vm.inscripcion.hora2Id = vm.horas2[0].id;
                    } else {
                        vm.horas = response.data.result;
                        vm.inscripcion.hora1Id = vm.horas[0].id;
                        vm.horas2 = response.data.result;
                        vm.inscripcion.hora2Id = vm.horas2[0].id;
                    }

                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        guardarInscripcion() {
            this.textBotonGuardarInscripcion = "Guardando inscripción...";
            this.disabledBotonGuardarInscripcion = 1;
            this.textoError = "";
            var errors = false;

            if (this.validations.nombre !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.nombre = false;
                errors = true;
            }

            if (this.validations.apellidos !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.apellidos = false;
                errors = true;
            }

            if (this.validations.club !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.club = false;
                errors = true;
            }


            if (this.validations.nombreTutor !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.nombreTutor = false;
                errors = true;
            }

            if (this.validations.apellidosTutor !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.apellidosTutor = false;
                errors = true;
            }

            if (this.validations.telefono !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.telefono = false;
                errors = true;
            }

            if (this.validations.email !== true) {
                this.textoError = "Revise los campos marcados antes de continuar";
                this.validations.email = false;
                errors = true;
            }

            if (this.inscripcion.modalidad.days === 2 && this.inscripcion.dia === this.inscripcion.dia2) {
                swal({
                    title: 'Atención',
                    text: 'No puede elegir el mismo dia para los dos entrenamientos',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                errors = true;
            }


            if (!errors) {
                if (this.informacionGeneral !== true) {
                    this.textoError = "Debe aceptar los términos de informacion general.";
                    this.textBotonGuardarInscripcion = "Crear cuenta";
                    this.disabledBotonGuardarInscripcion = 0;
                    return;
                }
                if (this.publicacionImagenes !== true) {
                    this.textoError = "Debe aceptar la toma y publicación de imágenes.";
                    this.textBotonGuardarInscripcion = "Crear cuenta";
                    this.disabledBotonGuardarInscripcion = 0;
                    return;
                }

                let vm = this;
                axios.post(this.$store.getters.apiUrl + 'players', {
                    inscripcion: this.inscripcion,
                    datosJugador: this.datosJugador,
                    datosTutor: this.datosTutor
                }).then(response => {
                    if (response.data.response) {
                        this.inscripcionOK = true;
                    } else {
                        this.textBotonGuardarInscripcion = "Crear cuenta";
                        this.disabledBotonGuardarInscripcion = 0;
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    this.textBotonGuardarInscripcion = "Guardar inscripción";
                    this.disabledBotonGuardarInscripcion = 0;
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            } else {
                this.textBotonGuardarInscripcion = "Guardar inscripción";
                this.disabledBotonGuardarInscripcion = 0;
            }


        },
        checkText() {
            let nombre = this.datosJugador.nombre;
            let apellidos = this.datosJugador.apellidos;
            let club = this.datosJugador.club;
            let nombreTutor = this.datosTutor.nombre;
            let apellidosTutor = this.datosTutor.apellidos;

            if (nombre === "") {
                this.validations.nombre = 0;
            } else {
                this.validations.nombre = true;
            }

            if (apellidos === "") {
                this.validations.apellidos = 0;
            } else {
                this.validations.apellidos = true;
            }

            if (club === "") {
                this.validations.club = 0;
            } else {
                this.validations.club = true;
            }

            if (nombreTutor === "") {
                this.validations.nombreTutor = 0;
            } else {
                this.validations.nombreTutor = true;
            }

            if (apellidosTutor === "") {
                this.validations.apellidosTutor = 0;
            } else {
                this.validations.apellidosTutor = true;
            }
        },
        checkTelefono() {
            this.datosTutor.telefono = this.datosTutor.telefono.trim();
            let tel = this.datosTutor.telefono;

            if (tel === "") {
                this.validations.telefono = 0;
            } else {
                var test = /\d{9}$/;
                var telReg = new RegExp(test);

                if (telReg.test(tel)) {
                    this.validations.telefono = true;
                } else {
                    this.validations.telefono = false;
                }
            }
        },
        checkEmail() {
            this.datosTutor.email = this.datosTutor.email.trim();
            let email = this.datosTutor.email;

            if (email === "") {
                this.validations.email = 0;
            } else {
                var test = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                var emailReg = new RegExp(test);

                if (emailReg.test(email)) {
                    this.validations.email = true;
                } else {
                    this.validations.email = false;
                }
            }
        },
    },
};
</script>
<style scoped>

.service-box {
    border: 1px solid #aaa;
    margin: 15px 0px;
    padding: 15px;
    border-radius: 5px;
}

#inicio {
    background: linear-gradient(87deg, #111 0%, #589dc3 120%) !important;
    min-height: 100vh;
}

.container {
    padding-top: 4em;
}

#logo-inicio {
    margin-bottom: 20px;
}

.posicion {
    padding: 20px;
}

.posicion:hover {
    background-color: rgba(88, 157, 195, 0.6);
    cursor: pointer;
}

.posicion-selected:hover {
    background-color: rgba(88, 157, 195, 0.9);
    cursor: pointer;
}

.posicion-selected {
    border-radius: 5px;
    color: white !important;
    background-color: rgba(88, 157, 195, 0.9);
}

.posicion-selected h2 {
    color: #eee !important;
}

.img-posicion {
    height: 100px;
    max-width: 120px;
}

.titulo-posicion {
    margin-top: 30px;
    margin-bottom: 10px;
}

#botonGuardarInscripcion {
    margin-top: 1rem;
    margin-bottom: 0.3rem;
}

.list-services {
    margin-top: 20px;
}

.list-services td {
    font-size: 1em;
}

@media (max-width: 600px) {
    .container {
        padding-top: 2rem;
    }
}
</style>
